import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Hammer from '@egjs/hammerjs';
import IndiscreteGestureHandler from "./IndiscreteGestureHandler";

var PinchGestureHandler = function (_IndiscreteGestureHan) {
  _inherits(PinchGestureHandler, _IndiscreteGestureHan);

  var _super = _createSuper(PinchGestureHandler);

  function PinchGestureHandler() {
    _classCallCheck(this, PinchGestureHandler);

    return _super.apply(this, arguments);
  }

  _createClass(PinchGestureHandler, [{
    key: "transformNativeEvent",
    value: function transformNativeEvent(_ref) {
      var scale = _ref.scale,
          velocity = _ref.velocity,
          center = _ref.center;
      return {
        focalX: center.x,
        focalY: center.y,
        velocity: velocity,
        scale: scale
      };
    }
  }, {
    key: "name",
    get: function get() {
      return 'pinch';
    }
  }, {
    key: "NativeGestureClass",
    get: function get() {
      return Hammer.Pinch;
    }
  }]);

  return PinchGestureHandler;
}(IndiscreteGestureHandler);

export default PinchGestureHandler;